class ResidentFilters {
    constructor($forms) {
        this.$forms = $forms;
        this.bindEvents();
    }

    bindEvents() {
        this.$forms.each((_, form) => {
            const $form = jQuery(form);
            const $inputs = $form.find("select, input[type='radio']");
            const rootAction = $form.data("action-root");
            const currentAction = $form.data("action-current");

            $inputs.on("change", (event) => {
                const targetName = event.target?.name;
                if (targetName === "year") {
                    const selectedOption = event.target?.options?.[event.target.selectedIndex];
                    const yearUrl = selectedOption?.dataset?.yearUrl;
                    if (yearUrl) {
                        const selectedCat = $form.find("input[name='cat']:checked").val();
                        if (selectedCat) {
                            const url = new URL(yearUrl, window.location.origin);
                            url.searchParams.set("cat", selectedCat);
                            window.location.href = url.toString();
                            return;
                        }
                        window.location.href = yearUrl;
                        return;
                    }
                }
                if (targetName === "year" && rootAction) {
                    $form.attr("action", rootAction);
                } else if (currentAction) {
                    $form.attr("action", currentAction);
                }

                $form.trigger("submit");
            });
        });
    }
}

export default ResidentFilters;
